module.exports = __webpack_public_path__ + "img/path-ac.d155c431.svg";